module.exports = __webpack_public_path__ + "static/img/build-it-once-use-it-over-and-over-again.9240e0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/job-description-generator/build-it-once-use-it-over-and-over-again.png
// module id = k1l6
// module chunks = 0